import React from 'react';
import { CheckCircle2, Clock, Circle } from 'lucide-react';

const STATUS_CONFIG = {
  not_started: {
    label: 'Not Started',
    icon: <Circle className="h-4 w-4" />,
    color: 'text-neutral-400',
    bg: 'bg-neutral-100'
  },
  in_progress: {
    label: 'In Progress',
    icon: <Clock className="h-4 w-4" />,
    color: 'text-blue-600',
    bg: 'bg-blue-50'
  },
  completed: {
    label: 'Completed',
    icon: <CheckCircle2 className="h-4 w-4" />,
    color: 'text-green-600',
    bg: 'bg-green-50'
  }
};

function InteractiveHomeworkProgress({ status = 'not_started', completionPercent = 0, lastSavedAt }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.not_started;

  const formattedSaved = lastSavedAt
    ? new Date(lastSavedAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : null;

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className={`flex items-center gap-1.5 text-sm font-medium ${config.color}`}>
          {config.icon}
          <span>{config.label}</span>
        </div>
        {formattedSaved && (
          <span className="text-xs text-neutral-400">Saved {formattedSaved}</span>
        )}
      </div>

      <div className="h-2 w-full rounded-full bg-neutral-100 overflow-hidden">
        <div
          className="h-full rounded-full bg-primary-600 transition-all duration-500"
          style={{ width: `${Math.max(0, Math.min(100, completionPercent))}%` }}
        />
      </div>

      <p className="text-xs text-neutral-500 text-right">{completionPercent}% complete</p>
    </div>
  );
}

export default InteractiveHomeworkProgress;
